import { useElplanBidClearLatestDate, useSentBidsToBroker } from 'api/elplan/elplan.api'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import InfoBanner from 'ui/components/InfoBanner/InfoBanner'
import Datetime from 'utils/datetime/datetime'
import { resolveBidActivityBannerState } from './BidActivityBanner.helper'

type BidActivityBannerProps = {
  elplanInfoId: number | undefined
  startTime: ISODateTime | undefined
  endTime: ISODateTime | undefined
}

export function BidActivityBanner({ elplanInfoId, startTime, endTime }: BidActivityBannerProps): ReactNode {
  const { t } = useTranslation()

  const sentBidsAtDate = useSentBidsToBroker(elplanInfoId, startTime, endTime, undefined)
  const clearedBidsAtDate = useElplanBidClearLatestDate(elplanInfoId, startTime)

  if (sentBidsAtDate.isSuccess && clearedBidsAtDate.isSuccess) {
    const state = resolveBidActivityBannerState(sentBidsAtDate.data?.latest_date, clearedBidsAtDate.data.latest_date)

    if (state.kind === 'sent') {
      return (
        <InfoBanner
          style="info"
          variant="text"
          text={t('Bids sent at {{sentDate}}.', { sentDate: Datetime.toLocalTime(state.date, 'hour') })}
        />
      )
    }

    if (state.kind === 'withdrawn') {
      return (
        <InfoBanner
          style="info"
          variant="text"
          text={t('Withdrawal sent at {{withdrawnDate}}.', {
            withdrawnDate: Datetime.toLocalTime(state.date, 'hour'),
          })}
        />
      )
    }
  }

  return <InfoBanner style="warning" variant="text" text={t('No bids sent')} />
}
